// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  TAB_VISUAL: { index: 0, value: 'Visual', key: 'visual' },
  TAB_HTML: { index: 1, value: 'HTML', key: 'html' },
  MESSAGES: {
    get M01() {
      return localizer.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_FIELD_NOT_UNIQUE');
    },
    get M02() {
      return localizer.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_FIELD_NOT_FOUND');
    },
    get M03() {
      return localizer.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_REPORT_NOT_FOUND');
    },
    get M04() {
      return localizer.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_REPORT_PART_NAME_NOT_UNIQUE');
    },
    get M05() {
      return localizer.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_REPORT_PART_NOT_FOUND');
    },
    get M06() {
      return localizer.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_NO_SUBTOTAL_INFO_SET_UP');
    },
    get M07() {
      return localizer.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_SUBTOTAL_INSIDE_REPEATER');
    },
    get M08() {
      return localizer.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_OPEN_NEW_FORM');
    },
    get M09() {
      return localizer.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_NO_GRAND_TOTOAL_INFO_SET_UP');
    },
    get M10() {
      return localizer.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_NOTHING_FOUND');
    },
    get M11() {
      return localizer.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_NOTHING_TO_REPLACE');
    },
    get M12() {
      return localizer.getText('COMMON_MESSAGES_MUST_BE_FUNCTION');
    },
    get M13() {
      return localizer.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_INCORRECT_GRAND_TOTAL_SYNTAX');
    },
    get M14() {
      return localizer.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_INCORRECT_SUBTOTAL_SYNTAX');
    },
    get M15() {
      return localizer.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_NO_TEMPLATE_DEFINED');
    },
    get M16() {
      return localizer.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_FIELD_NAME_ALIAS_NOT_UNIQUE');
    },
    get M17() {
      return localizer.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_LOB_FIELDS_OUTSIDE_REPEATER');
    },
    get ERROR_MESS_IN_LOW_LEVEL() {
      return localizer.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_SUBTOTAL_IN_CHILD_LEVEL');
    },
    get ERROR_MESSAGE_FOR_SUBTOTAL_IN_PARALLEL() {
      return localizer.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_DOES_NOT_ALLOW_SUBTOTAL_IN_PARALLEL');
    }
  },
  FORM_STYLE_DEFAULT: {
    borderStyle: 'solid',
    borderColor: '#000',
    borderWidth: 1,
    backgroundColor: '#FFF'
  },
  FORMAT_CONFIG: {
    FONT_NAME: {
      Arial: 'arial,helvetica,sans-serif',
      'Arial Black': 'arial black,sans-serif',
      'Book Antiqua': 'book antiqua,palatino,serif',
      'Courier New': 'courier new,courier,monospace',
      Georgia: 'georgia,palatino,serif',
      Helvetica: 'helvetica,arial,sans-serif',
      Impact: 'impact,sans-serif',
      'Lucida Console': 'lucida console,monaco,monospace',
      'Lucida Sans Unicode': 'lucida sans unicode,lucida grande,sans-serif',
      'Palatino Linotype': 'palatino linotype,book antiqua,palatino,serif',
      Roboto: 'roboto,sans-serif',
      Proxima: 'proxima nova,sans-serif',
      Tahoma: 'tahoma,arial,helvetica,sans-serif',
      'Times New Roman': 'times new roman,times,serif',
      Verdana: 'verdana,geneva,sans-serif'
    },
    FONT_SIZE: [
      '8px',
      '9px',
      '10px',
      '11px',
      '12px',
      '14px',
      '16px',
      '18px',
      '20px',
      '22px',
      '24px',
      '26px',
      '28px',
      '36px',
      '48px',
      '72px'
    ],
    HEADING: [
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_HEADING_1');
        },
        value: 'h1',
        className: 'format-h1'
      },
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_HEADING_2');
        },
        value: 'h2',
        className: 'format-h2'
      },
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_HEADING_3');
        },
        value: 'h3',
        className: 'format-h3'
      },
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_HEADING_4');
        },
        value: 'h4',
        className: 'format-h4'
      },
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_HEADING_5');
        },
        value: 'h5',
        className: 'format-h5'
      },
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_HEADING_6');
        },
        value: 'h6',
        className: 'format-h6'
      }
    ],
    BLOCK: [
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_PARAGRAPH');
        },
        value: 'p'
      },
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_BLOCKQUOTE');
        },
        value: 'blockquote'
      },
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_DIV');
        },
        value: 'div'
      },
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_PRE');
        },
        value: 'pre'
      }
    ],
    NUMBER_LIST: [
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_DEFAULT');
        },
        value: ''
      },
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_LOWER_ALPHA');
        },
        value: 'lower-alpha'
      },
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_LOWER_GREEK');
        },
        value: 'lower-greek'
      },
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_LOWER_ROMAN');
        },
        value: 'lower-roman'
      },
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_UPPER_ALPHA');
        },
        value: 'upper-alpha'
      },
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_UPPER_ROMAN');
        },
        value: 'upper-roman'
      }
    ],
    BULLET_LIST: [
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_DEFAULT');
        },
        value: ''
      },
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_CIRCLE');
        },
        value: 'circle'
      },
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_DISC');
        },
        value: 'disc'
      },
      {
        get label() {
          return localizer.getText('REPORT_PART_FORM_CONSTANTS_LABEL_SQUARE');
        },
        value: 'square'
      }
    ],
    REPEATER_LIST: [
      {
        get label() {
          return localizer.getText('COMMON_LABEL_ADD');
        },
        value: 'Add'
      },
      {
        get label() {
          return localizer.getText('COMMON_LABEL_REMOVE');
        },
        value: 'Remove'
      }
    ],
    SMARTTAG_LIST: [
      {
        get label() {
          return localizer.getText('COMMON_LABEL_DATE_TIME');
        },
        value: 'DateTime'
      },
      {
        get label() {
          return localizer.getText('COMMON_LABEL_SUBTOTAL');
        },
        value: 'Subtotal'
      },
      {
        get label() {
          return localizer.getText('COMMON_LABEL_GRAND_TOTAL');
        },
        value: 'GrandTotal'
      }
    ]
  },
  DEFAULT_SETTING_VALUE: {
    refreshIntervalDefault: {
      enable: false,
      isAll: true,
      latestRecord: 0,
      updateInterval: 0
    },
    boder: {}
  },

  DEFAULT_SORT_VALUE: 'ASC'
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ReportPartFormConstants.js